import { useTranslation } from '@kgc/i18n';
import { Link, useLocation } from 'react-router-dom';
import { BREADCRUMB_MAP } from './nav-config';

/**
 * Breadcrumb — pathname-alapú kenyérmorzsa navigáció
 * Döntés: NEM useMatches/createBrowserRouter (90+ route migráció túl kockázatos).
 * A BREADCRUMB_MAP pathname szegmens → i18n key fordítást végez.
 * @see tech-spec-nav-ux-overhaul.md F2-T3
 */
export function AppBreadcrumb() {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  // '/rental/active' → ['rental', 'active']
  // F9 fix: UUID és numerikus ID szegmenseket kiszűrjük (pl. /rental/abc123-uuid → csak /rental)
  const isDynamicId = (s: string) => /^\d+$/.test(s) || /^[0-9a-f]{8}-[0-9a-f]{4}-/i.test(s);
  const segments = pathname.split('/').filter(seg => seg && !isDynamicId(seg));

  if (segments.length === 0) return null;

  // Kumulatív href-ek: ['/rental', '/rental/active']
  const crumbs = segments.map((seg, idx) => ({
    segment: seg,
    href: '/' + segments.slice(0, idx + 1).join('/'),
    labelKey: BREADCRUMB_MAP[seg],
  }));

  // Ha egyik szegmensnek sincs mapping-je, ne jelenítsük meg
  const hasMapping = crumbs.some(c => c.labelKey);
  if (!hasMapping) return null;

  return (
    <nav
      aria-label="breadcrumb"
      className="flex items-center gap-1 px-4 py-1 border-b border-gray-100 dark:border-white/5"
    >
      {crumbs.map((crumb, idx) => {
        const isLast = idx === crumbs.length - 1;
        const label = crumb.labelKey ? t(crumb.labelKey) : crumb.segment;

        return (
          <span key={crumb.href} className="flex items-center gap-1">
            {idx > 0 && (
              <span className="text-[11px]" style={{ color: '#94a3b8' }} aria-hidden="true">
                ›
              </span>
            )}
            {isLast ? (
              <span
                className="text-[11px] font-medium"
                style={{ color: '#94a3b8' }}
                aria-current="page"
              >
                {label}
              </span>
            ) : (
              <Link
                to={crumb.href}
                className="text-[11px] transition-colors hover:underline"
                style={{ color: '#14b8a6' }}
              >
                {label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
